import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { BatchOrderList } from 'src/modules/batch/components/batch-list/component';
import { ExportDateRange } from 'src/modules/batch/components/export-date-range/component';
import { IBatch } from 'src/modules/batch/interfaces/batch';
import { BatchApiService } from 'src/modules/batch/services/batch-api-service';
import { BatchDataSource } from 'src/modules/batch/services/batch-data-source';
import { BehaviorSubject, Subscription as RxSubscription } from 'rxjs';

@Component({
    selector: 'finance-admin-dashboard',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class FinanceDashboard implements OnInit, OnDestroy {
  @Input() currentTab: BehaviorSubject<string>;

  private Subscriptions: RxSubscription[] = [];
  public loading: boolean;
  public Batches: IBatch[];
  public PageEvent: PageEvent;
  public DataSource = new BatchDataSource(this.BatchApi, 'finance-admin');

  public displayedColumns = ['date', 'total', 'order', 'actions'];

  constructor(private BatchApi: BatchApiService, private Dialog: MatDialog) {}

  ngOnInit() {

    this.Subscriptions.push(
      this.DataSource.loading.subscribe((loading) => (this.loading = loading))
    );
    this.Subscriptions.push(
      this.DataSource.connect().subscribe((Batches) => (this.Batches = Batches))
    );
    this.Subscriptions.push(
      this.DataSource.PageEvent.subscribe(
        (PageEvent) => (this.PageEvent = PageEvent)
      )
    );
    this.Subscriptions.push(
      this.DataSource.filter.subscribe(() =>
        this.DataSource.loadWithPageEvent(this.PageEvent)
      )
    );
    this.Subscriptions.push(
      this.currentTab.subscribe(
        (tab) =>
          !this.loading &&
          'finance-admin' === tab &&
          this.DataSource.loadWithPageEvent(this.PageEvent)
      )
    );
  }

  ngOnDestroy() {
    this.DataSource.disconnect();
    this.Subscriptions.forEach((Subscription) => Subscription.unsubscribe());
  }

  public exportRange() {
      const config = new MatDialogConfig();
      config.disableClose = true;
      config.data = {
        batchApi: this.BatchApi,
      };
      this.handleDialog(ExportDateRange, config);
  }

    async viewProduct(Batches) {
    const config = new MatDialogConfig();

    const batchOrders = await this.BatchApi.getBatchOrders('finance-admin', Batches.id);

    const orders = batchOrders['data'];
    const title = Batches.header
    config.data = {
      title,
      Item: orders,
      batchApi: this.BatchApi,
      id: Batches.id
    };
    this.Subscriptions.push(
      this.Dialog.open(BatchOrderList, config).afterClosed().subscribe()
    );
  }

  private handleDialog(component, config) {
    this.Subscriptions.push(
      this.Dialog.open(component, config)
        .afterClosed()
        .subscribe(() => {
          this.DataSource.loadWithPageEvent(this.PageEvent);
        })
    );
  }
}
